module.exports = __webpack_public_path__ + "static/img/qrcode.6cfce117.webp";